import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

export const init = () => {
  // Contador numérico, de 0 a XX
  const numberCounterItems = document.querySelectorAll(".auto-counter > .number");
  if (numberCounterItems.length > 0) {
    numberCounterItems.forEach((animItem) => {
      let animTrigger = animItem.closest(".anim-trigger");
      if (!animTrigger) {
        animTrigger = animItem.parentNode;
      }

      gsap
        .timeline({
          scrollTrigger: {
            trigger: animTrigger,
            start: "-=100% center",
            end: "bottom-=25% center",
            toggleActions: "play play reverse reverse",
            // markers: true,
          },
        })
        .from(animItem, {
          textContent: 0,
          duration: 4,
          delay: 0.25,
          ease: "power1.inOut",
          snap: { textContent: 1 },
          stagger: 1,
          // markers: true,
        });
    });
  }
};
